module.exports = __webpack_public_path__ + "resources/img/company-yt-thumbnail@2x.09a9be63.png";